export default __webpack_public_path__ + "static/media/RT.2c28db7c.svg";